export const TEST_PERIOD = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
} as const;

export type TestPeriod = (typeof TEST_PERIOD)[keyof typeof TEST_PERIOD];

export const TEST_PERIOD_OPTIONS: { value: TestPeriod; label: string }[] = [
  { value: TEST_PERIOD.WEEKLY, label: 'Weekly' },
  { value: TEST_PERIOD.MONTHLY, label: 'Monthly' },
];

export const TEST_PERIOD_NOUN: Record<TestPeriod, string> = {
  [TEST_PERIOD.WEEKLY]: 'week',
  [TEST_PERIOD.MONTHLY]: 'month',
};

export const TEST_LIMIT_CAP_BY_PERIOD: Record<TestPeriod, number> = {
  [TEST_PERIOD.WEEKLY]: 7,
  [TEST_PERIOD.MONTHLY]: 30,
};
